import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  // TODO: Move to app.config.ts
  baseUrl: string = environment.apiUrl;

  constructor(private HttpClient: HttpClient) {}


  /**
   * Retrieves all roles from the server.
   *
   * @returns An observable that emits an array of Role objects
   */
  getPeopleEvents(personId: number): Observable<Event[]> {
    return this.HttpClient.get<Event[]>(
      `${this.baseUrl}/events/peoples/`+personId
    );
  }

  getTeamEvents(teamId: number): Observable<Event[]> {
    return this.HttpClient.get<Event[]>(
      `${this.baseUrl}/events/teams/`+teamId
    );
  }

  getRoleEvents(roleId: number): Observable<Event[]> {
    return this.HttpClient.get<Event[]>(
      `${this.baseUrl}/events/roles/`+roleId
    );
  }

  getSkillEvents(roleId: number): Observable<Event[]> {
    return this.HttpClient.get<Event[]>(
      `${this.baseUrl}/events/skills/`+roleId
    );
  }
}
